import axios from 'axios'
import { message } from 'antd'
import StorageUtils from '../utils/StorageUtils'
import { isExpired, decodeToken } from "react-jwt"
import { BASE_API } from './index'

/**
 * 
 * @param {*} url 请求url
 * @param {*} type 请求方法
 * @param {*} data 请求数据
 * @param {*} require_auth 是否需要携带token认证
 * @param {*} config 其他配置, 如请求头的配置参数
 * @returns 
 */
export default function ajax(url, type='GET', data={}, require_auth = false, config={}) {
    let { access, refresh } = StorageUtils.getUser()
    let auth_header = {}
    const accessTokenIsExpired = isExpired(access)
    const refreshTokenIsExpired = isExpired(refresh)

    // 如果refresh token已经过期，则不再请求新的access token，退出当前用户，重新登录
    if (require_auth && refreshTokenIsExpired) {
        StorageUtils.removeUser()
        return false
    }

    return new Promise((resolve, reject) => {
        let promise

        // 在需要认证的api接口请求中，加入access token
        if (require_auth) {
            if (access && refresh) {
                // 如果access token过期，则用refresh token获取新的access token
                if (accessTokenIsExpired) {
                    axios({ method: 'post', url: BASE_API + '/token/refresh', data: {refresh_token: refresh}})
                    .then((result) => {
                        if (result.data.code === 0) {
                            StorageUtils.saveUser({access: result.data.data.access, refresh: result.data.data.refresh})
                            access = result.data.data.access
                        } else {
                            message.error('Refresh token error.')
                        }
                    }).catch(error => {
                        message.error('Request failed: ' + error.message)
                    })
                    
                }
                auth_header = { headers: {'AUTHORIZATION':`Bearer ${access}`}}
            }

            if (JSON.stringify(config) === '{}') {
                config = auth_header
            }
        }
        
        if (type === 'GET') {
            promise = axios({ method: 'get', url: url, params: data, ...config })
        } else if (type === 'POST') {
            promise = axios({ method: 'post', url: url, data: data, ...config })
        }

        promise.then(response => {
            resolve(response.data)
        }).catch(error => {
            message.error('Request failed. ' + error)
        })
    })
}
